import { createBrowserRouter, Navigate } from "react-router-dom";

import AppNavigation from "./AppNavigation";
import Login from "views/login/Login";
import Root from "views/root/Root";
import Home from "views/home/Home";
import CreateCampaign from "views/campaign/CreateCampaign";
import CampaignAddressBook from "views/campaign/CampaignAddressBook";
import EditCampaign from "views/campaign/EditCampaign";
import {
    loadCampaigns,
    loadCampaignCreationData,
    loadCampaignEditionData,
    loadCampaignById,
    loadAddressBooks,
    loadAddressBookDetails,
    loadStatsCampaing,
    loadDwhRequests,
    loadSettings,
    loadCampaignsAddressBooks,
    loadCampaignByIdAndEmailingDb,
    loadUnsubscribers,
    loadHlroperations
} from "./loaders";
import {
    addressBookAction,
    createCampaign,
    addressBookDetailsAction,
    deleteCampaign,
    editCampaign,
    login,
    sendTest,
    switchDefaultCmAccount,
    addressBookListAction,
    homeAction,
    cancelCampaigns,
    cloneCampaign,
    checkNumberByHlr,
    register,
    activateAccountViaCode,
    loginWithEmailAndPassword,
} from "./actions";
import SendTest from "views/campaign/SendTest";
import AddressBooks from "views/address-books/AddressBooks";
import AddressBookDetails from "views/address-books/AddressBookDetails";
import CampaignSchedule from "views/campaign/CampaignSchedule";
import CampaignStats from "views/campaign/CampaignStats";
import SegmentList from "./../views/dwh/SegmentList";
import SwitchCmAccount from "views/settings/SwitchCmAccount";
import DraftCampaign from "views/campaign/CampaignList/draft/DraftCampaign";
import SentCampaign from "views/campaign/CampaignList/sent/SentCampaign";
import ScheduledCampaign from "views/campaign/CampaignList/schedule/ScheduledCampaign";
import CloneCampaign from "./../views/campaign/CloneCampaign";
import Unsubscribers from "./../views/Unsubscribers/Unsubscribers";
import Reporting from "views/campaign/Reporting";
import CheckNumberHLR from "views/hlroperation/CheckNumberHLR";
import Register from "views/signup/register";
import ActivateAccount from "views/activate-account/activateAccountForm";
import CampaignAddressBookVersion2 from "views/campaign/CampagneAddressBookVersion2";
import LayoutCampaignAddressBook from "views/campaign/Layout/LayoutCampaignAddressBook";

const router = createBrowserRouter([
    {
        path: AppNavigation.Login,
        element: <Login />,
        action: loginWithEmailAndPassword,
        // action: login,
        errorElement: <Login />,
    },

    // ================================================== PATH REGISTER ====================================
    {
        path: AppNavigation.Register,
        element: <Register />,
        action : register,
        errorElement: <Register />,
    },

    // ========================================== PATH SEND ACTIVATION CODE ====================================
    {
        path: AppNavigation.SendActivationCode,
        element: <ActivateAccount />,
        action: activateAccountViaCode,
        errorElement: <ActivateAccount />,
    },
    {
        path: AppNavigation.Home,
        element: <Root />,
        loader: loadSettings,
        children: [
            {
                index: true,
                element: <Navigate to={AppNavigation.Campaigns} replace={true} />,
            },
            {
                path: AppNavigation.Campaigns,
                element: <Home />,
                loader: loadCampaignsAddressBooks,
                action: homeAction,
            },
            {
                path: AppNavigation.DraftCampaigns,
                element: <DraftCampaign />,
                loader: loadCampaignsAddressBooks,
                action: homeAction,
            },
            {
                path: AppNavigation.ScheduledCampaigns,
                element: <ScheduledCampaign />,
                loader: loadCampaignsAddressBooks,
                action: cancelCampaigns,
            },
            {
                path: AppNavigation.SentCampaigns,
                element: <SentCampaign />,
                loader: loadCampaignsAddressBooks,
                action: homeAction,
            },

            {
                path: AppNavigation.CreateCampaign,
                element: <CreateCampaign />,
                loader: loadCampaignCreationData,
                action: createCampaign,
            },
            {
                path: AppNavigation.EditCampaign,
                element: <EditCampaign />,
                loader: loadCampaignEditionData,
                action: editCampaign,
            },
            {
                path: AppNavigation.CloneCampaign,
                element: <CloneCampaign />,
                loader: loadCampaignEditionData,
                action: cloneCampaign,
            },
            {
                path: AppNavigation.CampaignAddressBook,
                element: <CampaignAddressBook />,
                // element: <LayoutCampaignAddressBook />,
                loader: loadCampaignByIdAndEmailingDb,
                action: addressBookAction,
            },
            {
                path: AppNavigation.CampaignSendTest,
                element: <SendTest />,
                loader: loadCampaignById,
                action: sendTest,
            },
            {
                path: AppNavigation.AddressBooks,
                element: <AddressBooks />,
                loader: loadAddressBooks,
                action: addressBookListAction,
            },
            {
                path: AppNavigation.AddressBookDetail,
                element: <AddressBookDetails />,
                loader: loadAddressBookDetails,
                action: addressBookDetailsAction,
            },
            {
                path: AppNavigation.Unsubscribers,
                element: <Unsubscribers />,
                loader: loadUnsubscribers,
                // action: addressBookListAction
            },
            {
                path: AppNavigation.ScheduleCampaing,
                element: <CampaignSchedule />,
                loader: loadAddressBooks,
                // action: addressBookDetailsAction,
            },
            {
                path: AppNavigation.DwhRequests,
                element: <SegmentList />,
                loader: loadDwhRequests,
                // action: addressBookDetailsAction,
            },
            {
                path: AppNavigation.Reporting,
                element: <Reporting />,
                // loader: loadDwhRequests,
                // action: addressBookDetailsAction,
            },
            {
                path: AppNavigation.Settings,
                element: <SwitchCmAccount />,
                loader: loadSettings,
                action: switchDefaultCmAccount,
            },
            {
                path: AppNavigation.CheckNumberHLR,
                element: <CheckNumberHLR />,
                loader: loadHlroperations,
                action: checkNumberByHlr,
            },
        ],
    },
]);


export default router;
